import React, {useState, createRef, useEffect, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {getCookie} from '../../../../utils/getCookie';
import {useForm, Controller} from 'react-hook-form';
import dateformat from 'dateformat';
import useOutsideClick from '@ibibo/use-outside-click';
import SelectBox from '../../common/SelectBox/SelectBox';
import TextInput from '../../common/TextInput/TextInput';
import Uploader from '../../common/Uploader/Uploader';
import CalendarBlock from '../../Wallet/RightBlock/WalletStatement/WalletCalendar';
import {postRefundRaiseRequest} from '@ibibo/myaccount-reducer';
import {myPartnerBanksForGccData} from './mock.js';
import * as S from './RaiseWalletRequest.styles';

const RaiseWalletRequestGcc = ({closeModal, setModalFlag}) => {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,

    formState: {errors, isValid},
  } = useForm({mode: 'all', shouldUnregister: true});

  const dispatch = useDispatch();

  const startDateRef = createRef();
  const [calendarMode, setCalendarMode] = useState('start');
  const [showDate, setShowDate] = useState(false);

  const [calenderHandle, setCalenderHandle] = useState(false);
  const [failureMessage, setFailureMessage] = useState('');

  const [walletStatementDates, setDates] = useState({
    startDate: new Date(),
  });

  const closeModalClick = () => {
    closeModal();
  };

  const showDateHandler = () => {
    setShowDate(true);
    setCalenderHandle(true);
  };

  useOutsideClick(startDateRef, () => {
    setCalendarMode('');
    setShowDate(false);
  });

  const updateQueryCaller = data => {
    if (data?.startDate) {
      setDates({
        startDate: data.startDate,
      });
      setValue('transactionDateTime', dateformat(data?.startDate, 'yyyy/mm/dd'));
    }
    setShowDate(false);
    setCalenderHandle(false);
  };

  const dropdownValue = value => {
    setValue('myPartnerBankName', value?.text);
  };

  const onSubmit = data => {
    dispatch(
      postRefundRaiseRequest(
        {
          paymentMode: data.paymentMode,
          transactionDateTime: `${dateformat(data?.transactionDateTime, 'yyyy-mm-dd')}`,
          transactionAmount: data?.transactionAmount,
          utr: data?.utr,
          bankName: data?.bankName,
          myPartnerBankName: data?.myPartnerBankName,
          senderAccountNumber: data?.senderAccountNumber,
          senderAccountName: data?.senderAccountName,
          paymentScreenshot: data?.paymentScreenshot?.[0],
        },
        () => {
          location.reload(); //reload the page after successful request to show the request in table
        },
        () => {
          setFailureMessage('Your request has been raised successfully');
        },
      ),
    );
  };

  return (
    <S.FormCont>
      <form onSubmit={handleSubmit(onSubmit)}>
        <S.FormBody>
          <S.FormHeading>Raise Your request</S.FormHeading>
          <S.CloseBtn onClick={closeModalClick} />

          <S.FormWrap>
            <S.FormLeft>
              <S.FrmRow>
                <S.FrmColLeft>
                  <label>Payment Mode</label>
                </S.FrmColLeft>
                <S.FrmColRight>
                  <Controller
                    name="paymentMode"
                    control={control}
                    defaultValue=""
                    rules={{required: 'This field is required'}} // Optional validation rules
                    render={({field}) => (
                      <TextInput {...field} type="text" placeholder="Enter Payment Mode" />
                    )}
                  />
                  {errors?.paymentMode && <S.Error>{errors?.paymentMode?.message}</S.Error>}
                </S.FrmColRight>
              </S.FrmRow>
              <S.FrmRow>
                <S.FrmColLeft>
                  <label>Transaction Date</label>
                  <p>Select from dropdown</p>
                </S.FrmColLeft>
                <S.FrmColRight>
                  <Controller
                    name="transactionDateTime"
                    control={control}
                    defaultValue={`${dateformat(walletStatementDates?.startDate, 'yyyy/mm/dd')}`}
                    rules={{required: 'This field is required'}} // Optional validation rules
                    render={({field}) => (
                      <S.Transaction>
                        <S.StatementTimeWrap onClick={showDateHandler}>
                          <S.StatementTimeInnerWrap>
                            <S.FromTimeWrap>
                              <S.FromTimeMainText>
                                {dateformat(walletStatementDates?.startDate, 'dd/mm/yyyy')}
                              </S.FromTimeMainText>
                            </S.FromTimeWrap>
                            {showDate && calenderHandle && (
                              <S.CalendarWrapperFrom>
                                <CalendarBlock
                                  ref={startDateRef}
                                  isSearchWidget={true}
                                  isStartMode={calendarMode === 'start'}
                                  onSelection={() => setCalendarMode('start')}
                                  updateQueryCaller={updateQueryCaller}
                                  startDate={walletStatementDates?.startDate}
                                  //endDate={new Date()}
                                  isEndMode={calendarMode === 'end'}
                                />
                              </S.CalendarWrapperFrom>
                            )}
                          </S.StatementTimeInnerWrap>
                        </S.StatementTimeWrap>
                        {/*<input type="time" onChange={handleTimeChange} />*/}
                      </S.Transaction>
                    )}
                  />
                  {errors?.transactionDateTime && (
                    <S.Error>{errors?.transactionDateTime.message}</S.Error>
                  )}
                </S.FrmColRight>
              </S.FrmRow>
              <S.FrmRow>
                <S.FrmColLeft>
                  <label>Transaction Amount</label>
                </S.FrmColLeft>
                <S.FrmColRight>
                  <Controller
                    name="transactionAmount"
                    control={control}
                    defaultValue=""
                    rules={{required: 'This field is required'}} // Optional validation rules
                    render={({field}) => (
                      <TextInput
                        hasRupeesSymbol
                        {...field}
                        placeholder="Enter Your Amount"
                        id={1}
                        name={'AED'}
                        width={'300px'}
                        type="number"
                        ccdeCookie="AE"
                      />
                    )}
                  />
                  {errors?.transactionAmount && (
                    <S.Error>{errors?.transactionAmount?.message}</S.Error>
                  )}
                </S.FrmColRight>
              </S.FrmRow>
              <S.FrmRow>
                <S.FrmColLeft>
                  <label>{'Reference ID'}</label>
                  <p>Prefilled from your bank statement</p>
                </S.FrmColLeft>
                <S.FrmColRight>
                  <Controller
                    name="utr"
                    control={control}
                    defaultValue=""
                    rules={{required: 'This field is required'}} // Optional validation rules
                    render={({field}) => (
                      <TextInput
                        isTooltipTrue={true}
                        toolTipHeading={'NEFT Reference ID'}
                        toolTipText={
                          'Please quote the number reflecting in your statement/transaction history'
                        }
                        {...field}
                        placeholder="Reference ID"
                      />
                    )}
                  />
                  {errors?.utr && <S.Error>{errors?.utr?.message}</S.Error>}
                </S.FrmColRight>
              </S.FrmRow>
              <S.FrmRow>
                <S.FrmColLeft>
                  <label>{'Sender Bank Name'}</label>
                </S.FrmColLeft>
                <S.FrmColRight>
                  <Controller
                    name="bankName"
                    control={control}
                    defaultValue=""
                    rules={{required: 'This field is required'}} // Optional validation rules
                    render={({field}) => <TextInput {...field} placeholder="Enter Bank Name" />}
                  />
                  {errors?.bankName && <S.Error>{errors?.bankName?.message}</S.Error>}
                </S.FrmColRight>
              </S.FrmRow>
              <S.FrmRow>
                <S.FrmColLeft>
                  <label>{'Sender Account Number'}</label>
                </S.FrmColLeft>
                <S.FrmColRight>
                  <Controller
                    name="senderAccountNumber"
                    control={control}
                    defaultValue=""
                    render={({field}) => (
                      <TextInput {...field} placeholder="Sender Account Number" />
                    )}
                  />
                  {errors?.senderAccountNumber && (
                    <S.Error>{errors?.senderAccountNumber?.message}</S.Error>
                  )}
                </S.FrmColRight>
              </S.FrmRow>
              <S.FrmRow>
                <S.FrmColLeft>
                  <label>{'Sender Account Name'}</label>
                </S.FrmColLeft>
                <S.FrmColRight>
                  <Controller
                    name="senderAccountName"
                    control={control}
                    defaultValue=""
                    render={({field}) => <TextInput {...field} placeholder="Sender Account Name" />}
                  />
                  {errors?.senderAccountName && (
                    <S.Error>{errors?.senderAccountName?.message}</S.Error>
                  )}
                </S.FrmColRight>
              </S.FrmRow>
              <S.FrmRow>
                <S.FrmColLeft>
                  <label>{'myPartner Bank Name'}</label>
                  <p>Select from the dropdown</p>
                </S.FrmColLeft>
                <S.FrmColRight>
                  <Controller
                    name="myPartnerBankName"
                    control={control}
                    defaultValue=""
                    rules={{required: 'This field is required'}} // Optional validation rules
                    render={({field: {onChange, value}}) => (
                      <SelectBox
                        placeholder="Select myPartner Bank Name"
                        options={myPartnerBanksForGccData}
                        width={'300px'}
                        isError={false}
                        errorMsg=""
                        onChange={value => {
                          onChange(value);
                        }}
                        value={value}
                      />
                    )}
                  />
                  {errors?.myPartnerBankName && (
                    <S.Error>{errors?.myPartnerBankName?.message}</S.Error>
                  )}
                </S.FrmColRight>
              </S.FrmRow>
            </S.FormLeft>
            <S.FormRight>
              <Controller
                name="paymentScreenshot"
                control={control}
                rules={{required: 'This field is required'}}
                defaultValue={[]}
                render={({field: {value, onChange}}) => {
                  return (
                    <Uploader
                      uploadedFiles={value}
                      onChange={_event => {
                        onChange?.(_event);
                      }}
                    />
                  );
                }}
              />
              {errors?.paymentScreenshot && <S.Error>{errors?.paymentScreenshot.message}</S.Error>}
            </S.FormRight>
          </S.FormWrap>
        </S.FormBody>
        <S.FormFooter>
          {failureMessage && <span>{failureMessage}</span>}{' '}
          <S.BtnSubmit type="submit" disabled={!isValid}>
            SUBMIT your Request
          </S.BtnSubmit>
        </S.FormFooter>
      </form>
    </S.FormCont>
  );
};

export default RaiseWalletRequestGcc;
